import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: 'app-observaciones-dte',
  templateUrl: './observaciones-dte.component.html',
  styleUrls: ['./observaciones-dte.component.scss']
})
export class ObservacionesDteComponent implements OnInit {
  public clicked: boolean = false;
  public ObservacionesGroupForm: FormGroup;

  @Output() observacionesChange = new EventEmitter<string>();

  constructor(private builder: FormBuilder) { }
  clickedAccordionButton() {
    this.clicked = !this.clicked;
  }

  ngOnInit(): void {
    this.ObservacionesGroupForm = this.builder.group({
      observaciones: [''] 
    });
    this.ObservacionesGroupForm.get('observaciones').valueChanges
      .subscribe(value => {
        this.observacionesChange.emit(value);
      });
  }
}
